<template>
  <div v-if="renderReady">
    <label v-if="getTitle">
      <template>{{ getTitle }}</template>

      <w-tooltip v-if="tooltipContent && tooltipContent.length">{{tooltipContent}}</w-tooltip>
    </label>

    <monaco-editor
      v-model="model.$value"
      class="editor"
      :class="{ 'is-invalid': this.model.$error }"
      :options="monacoOptions"
      :language="language"
      @editorDidMount="startListeners"
    />

    <w-error :model="model" />
  </div>
</template>

<script>
import MonacoEditor from 'vue-monaco';

import modelMixin from '../mixins/modelMixin';
import WError from './error.vue';
import WTooltip from './tooltip.vue';

export default {
  name: 'w-monaco',
  components: {MonacoEditor, WError, WTooltip},
  mixins: [modelMixin],
  vmodel: true,
  data() {
    return {editor: undefined};
  },
  props: {
    language: {
      type: String,
      required: false,
      default: 'javascript'
    }
  },
  computed: {
    monacoOptions() {
      if (this.disabled) {
        return {readOnly: true};
      }
    }
  },
  methods: {
    startListeners(editor) {
      this.editor = editor;
      editor.onDidFocusEditorText(() => this.onFocus());
      editor.onDidBlurEditorText(() => this.onBlur());
    }
  }
};
</script>

<style>
.editor {
  min-height: 400px;
  border: 1px solid #cacaca;
}

.editor.is-invalid {
  border-color: #dc3545 !important;
}
</style>